import { Suspense, useEffect } from 'react'
import { get } from 'lodash'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import {
  brokerGuidStore,
  commercialCombinedFormStore,
} from '@/store/CommercialCombinedFormStore'
import { BrokerBuyRouter } from '@/router/brokerBuyRouter'

const BrokerBuyRouteController = () => {
  const { step } = useParams()
  const navigate = useNavigate()
  const { stepAsEnum } = commercialCombinedFormStore()
  const location = useLocation()
  const { setGuid, guid } = brokerGuidStore()

  const RenderStep = get(get(BrokerBuyRouter, step || ''), 'element')

  const stepManager = (goTo: string) => {
    navigate(goTo)
  }

  useEffect(() => {
    if (location.state?.from !== 'commercialCombined' && guid) {
      setGuid(undefined)
    }

    const step1 = BrokerBuyRouter.step1.href

    // if there is no steps
    if (!RenderStep || !step) {
      stepManager(step1)
    }

    // ignore someone change steps via url
    if (step) {
      const numberOfStep = step
      if (numberOfStep !== stepAsEnum) {
        const goTo = BrokerBuyRouter[stepAsEnum]
        stepManager(goTo.href)
      }
    }
  }, [])

  return (
    <>
      {RenderStep && (
        <Suspense>
          <RenderStep />
        </Suspense>
      )}
    </>
  )
}

export default BrokerBuyRouteController
